import React from "react";
import { BsTelephone } from "react-icons/bs";
import { HiOutlineMail } from "react-icons/hi";

const Contact = ({ copyPhoneToClipboard, copyAdressToClipboard }) => {
  return (
    <div className="my-10 dark:text-[#E0E2DB]">
      {/* cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div
          onClick={() => {
            copyPhoneToClipboard();
          }}
          className="border hover:scale-105 cursor-copy rounded-lg flex flex-col justify-center items-center p-10"
        >
          {/* icon */}
          <div className="text-7xl py-8">
            <BsTelephone />
          </div>
          {/* text */}
          <h1 className="number font-bold">+213555 02 39 05</h1>
        </div>
        <div
          onClick={() => {
            copyAdressToClipboard();
          }}
          className="border rounded-lg hover:scale-105 cursor-copy flex flex-col justify-center items-center p-10"
        >
          {/* icon */}
          <div className="text-7xl py-8">
            <HiOutlineMail />
          </div>
          {/* text */}
          <h1 className="email  font-bold">faicalbounedjar4real@gmail.com</h1>
        </div>
      </div>
    </div>
  );
};

export default Contact;
